import React from "react";
import { connect } from "react-redux";

// Components
import Searchbar from "../../utils/searchbar/Searchbar";
import SearchTrainingEducation from "./SearchTrainingEducation";

// State
import { addRoute } from "../../../store/actions/route";

class AdminTrainingEducation extends React.Component {
	constructor(props) {
		super(props);

		this.props.addRoute(this.props.match);
	}

	render() {
		return (
			<React.Fragment>
				<Searchbar
					placeholder={"Search training education"}
					component={SearchTrainingEducation}
					searchEndpoint={"search/training-education"}
					basePath={null}
					userType="admin"
				/>
			</React.Fragment>
		);
	}
}

export default connect(
	null,
	{ addRoute }
)(AdminTrainingEducation);



// WEBPACK FOOTER //
// ./src/components/admin/training-education/AdminTrainingEducation.js